// extracted by mini-css-extract-plugin
module.exports = {"image":"shineup-module--image--22XoD","content":"shineup-module--content--3FnpY"};